<template>
  <div class="customerBasicInfo">
    <QS-h4-title title="基本信息" />
    <QS-column-box
      v-if="source.customerType == 2"
      :source="source"
      :column="3"
      labelWidth="150"
      separator=":"
      :list="list"
    >
      <template slot="tagList">
        <template v-if="Array.isArray(source.tagList) && source.tagList.length !== 0">
          <el-tag v-for="item in source.tagList" :key="item.id" class="customer-tag">{{ item.name }}</el-tag>
        </template>
        <template v-else>-</template>
      </template>
      <template slot="businessLicenceUrl">
        <EnlargeImg :imgSrc="source.businessLicenceUrl||''" class="avatar" />
      </template>
    </QS-column-box>
    <QS-column-box
      :source="source"
      :list="list"
      :column="3"
      labelWidth="150"
      separator=":"
      v-else
    >
      <template slot="ethnicity">
        {{nation}}
      </template>
      <template slot="tagList">
        <template v-if="Array.isArray(source.tagList) && source.tagList.length !== 0">
          <el-tag v-for="item in source.tagList" :key="item.id" class="customer-tag">{{ item.name }}</el-tag>
        </template>
        <template v-else>-</template>
      </template>
    </QS-column-box>
  </div>
</template>
<script>
import dict from '@/store/dict/driverDict'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 民族
    nation() {
      return dict.NATION_DICT()[this.source.ethnicity] || '-'
    },
  },
}
</script>

<style lang="scss" scoped>
.customerBasicInfo{
  .positive{
    display: flex;
    width: 50%;
  }

  .reverse{
    display: flex;
    width: 50%;
  }
  .customer-tag {
    margin-right: 4px;
    margin-bottom: 2px;
  }
  ::v-deep .el-column-box__content {
    flex-wrap: wrap;
  }
}
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
